import axios from 'axios';
import { getApiBaseUrl } from '../utils/getKeys';
import { setupInterceptors } from './interceptors';

const API_BASE_URL = getApiBaseUrl();

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  //withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();

  // Avoid sending Content-Type for methods without a request body.
  if (["get", "head", "delete", "options"].includes(method) && config.headers) {
    delete config.headers["Content-Type"];
    delete config.headers["content-type"];
  }

  return config;
});



/*apiClient.interceptors.request.use((config) => {
  const token = store.getState().auth.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});*/

setupInterceptors(apiClient);

export default apiClient;